import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
  import.meta.env.VITE_FACTURACION_SYNC_API_URL || "http://localhost:4007/api";

export const axiosFacturacionSync: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(axiosFacturacionSync);

axiosFacturacionSync.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) =>
    Promise.reject(error.response || "Algo salió mal"),
);
